var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"materials-full-height"},[_c('div',{staticClass:"images-materials"},[_c('DinamicGridImages',{attrs:{"materials":_vm.materiales},on:{"selectMaterial":_vm.selectMaterial}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }